import type { SortingState } from '@tanstack/table-core'

import { parseAsArrayOf, parseAsBoolean, parseAsInteger, parseAsString } from 'nuqs/server'

import type { TableSettingsState } from '@/helpers/cookieStorage/userSettings/tableSettings/shared'

export const PAGE_SIZE = 10

export const CURATOR_VAULTS_STORAGE_KEY = 'curatorVaults'
export const CURATOR_VAULTS_STORAGE_VERSION = 4

export const COLUMN_IDS = {
  Network: 'network',
  Vault: 'vault',
  Deposits: 'deposits',
  Liquidity: 'liquidity',
  Exposure: 'exposure',
  Apy: 'apy'
} as const

export const CURATOR_VAULTS_INITIAL_SORTING: SortingState = [
  {
    id: COLUMN_IDS.Deposits,
    desc: true
  }
]

export const CURATOR_VAULTS_DEFAULT_TABLE_SETTINGS: TableSettingsState = {
  sorting: CURATOR_VAULTS_INITIAL_SORTING,
  columnFilters: [],
  version: CURATOR_VAULTS_STORAGE_VERSION,
  columnOrder: [],
  columnVisibility: {}
}

export interface CuratorVaultsFilters {
  v2?: boolean | null
  assets: string[]
  chains?: number[]
  search: string
  sorting?: {
    id: string
    desc: boolean
  }
}

export const curatorVaultsUrlFilterParser = {
  search: parseAsString.withDefault(''),
  assets: parseAsArrayOf(parseAsString).withDefault([]),
  chains: parseAsArrayOf(parseAsInteger).withDefault([]),
  v2: parseAsBoolean.withDefault(false)
}
